import type { RegulatorDetailData } from '../api/regulator-list'

export type RegulatorDetailLayout = {
  hasDisclosureColumn: boolean
  hasMemberColumn: boolean
  hasBlacklistColumn: boolean
  shouldFlattenComplaintChannel: boolean
}

/** 根据左侧模块数量决定投诉渠道是否迁移到左侧。 */
export const resolveRegulatorDetailLayout = (detail: RegulatorDetailData | null | undefined): RegulatorDetailLayout => {
  const hasDisclosureColumn = Boolean(detail?.disclosureList.length)
  const hasMemberColumn = Boolean(detail?.memberList.length)
  const hasBlacklistColumn = Boolean(detail?.blacklistList.length)
  const populatedLeftColumnCount = [hasDisclosureColumn, hasMemberColumn, hasBlacklistColumn].filter(Boolean).length

  return {
    hasDisclosureColumn,
    hasMemberColumn,
    hasBlacklistColumn,
    shouldFlattenComplaintChannel: populatedLeftColumnCount === 1 && Boolean(detail?.complaintChannelList.length),
  }
}
